import { useLayout } from "../context/LayoutContext"
import { ThemeMode } from "../context/LayoutContext/types"
import { LOGO, LOGO_FULL, LOGO_DARK_MODE, LOGO_FULL_DARK_MODE } from "../js/const"

export function useLogos() {
  const { themeMode } = useLayout()
  const isDark = themeMode === ThemeMode.DARK

  return {
    logo: isDark ? LOGO_DARK_MODE : LOGO,
    logoFull: isDark ? LOGO_FULL_DARK_MODE : LOGO_FULL,
  }
}
